<template>
    <div>
        <div v-if="bourse_dossards_items.length == 0">Aucun dossard n'est actuellement en vente pour cet évènement.
        </div>
        <div v-else>Il y a actuellement {{ bourse_dossards_items.length }} dossards en vente pour cet évènement.</div>

        <div v-if="bourse_dossards_items.length > 0">
            <div v-if="is_mobile">
                <div v-for="item in bourse_dossards_items" :key="item.id" class="spo-card pa-2 rounded bordered mb-2">
                    <div class="font-weight-bold">{{ parcours_name(item) }}</div>
                    <div>
                        <span v-if="item.associated_equipe_inscriptions.length > 0">Equipe</span>
                        <span v-else>Solo</span>
                    </div>
                    <div v-if="item.options.length == 0">Aucune option</div>

                    <div v-else class="d-flex flex-wrap ga-1">
                        <v-chip density="compact" v-for="option in item.options" :key="option.id">
                            <v-icon size="small" :icon="get_icon(option.type)"></v-icon>
                            {{ option.quantite }}x
                            {{ option.nom }}
                            <span v-if="option.size != ''">({{ option.size }})</span></v-chip>
                    </div>
                    <div v-if="item.associated_equipe_inscriptions.length > 0">

                        <div v-for="equipe_inscription in item.associated_equipe_inscriptions"
                            :key="equipe_inscription.id" class="d-flex flex-wrap ga-1">
                            <v-chip density="compact" v-for="option in equipe_inscription.options" :key="option.id">
                                <v-icon size="small" :icon="get_icon(option.type)"></v-icon>
                                {{ option.quantite }}x
                                {{ option.nom }}
                                <span v-if="option.size != ''">({{ option.size }})</span></v-chip>
                        </div>
                    </div>
                    <div>Mis en vente le {{ $moment(item.created_at).format('DD/MM/YYYY à HH:mm') }}</div>
                    <div class="mt-2">
                        <v-btn variant="flat" color="primary-dark" size="small" class="text-bold w-100"
                            @click="buy_dossard(item)">
                            Acheter !
                        </v-btn>
                    </div>
                </div>
            </div>
            <div v-else>
                <v-table density="compact" v-if="bourse_dossards_items.length > 0">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Parcours</th>
                            <th>Options</th>
                            <th>Date de mise en vente</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in bourse_dossards_items" :key="item.id">
                            <td>
                                <span v-if="item.associated_equipe_inscriptions.length > 0">Equipe</span>
                                <span v-else>Solo</span>
                            </td>
                            <td>
                                <b>{{ parcours_name(item) }} </b>
                            </td>
                            <td>

                                <div v-if="item.options.length == 0">Aucune option</div>

                                <div v-else class="d-flex flex-wrap ga-1">
                                    <v-chip density="compact" v-for="option in item.options" :key="option.id">
                                        <v-icon size="small" :icon="get_icon(option.type)"></v-icon>
                                        {{ option.quantite }}x
                                        {{ option.nom }}
                                        <span v-if="option.size != ''">({{ option.size }})</span></v-chip>
                                </div>
                                <div v-if="item.associated_equipe_inscriptions.length > 0">

                                    <div v-for="equipe_inscription in item.associated_equipe_inscriptions"
                                        :key="equipe_inscription.id" class="d-flex flex-wrap ga-1">
                                        <v-chip density="compact" v-for="option in equipe_inscription.options"
                                            :key="option.id">
                                            <v-icon size="small" :icon="get_icon(option.type)"></v-icon>
                                            {{ option.quantite }}x
                                            {{ option.nom }}
                                            <span v-if="option.size != ''">({{ option.size }})</span></v-chip>
                                    </div>
                                </div>
                            </td>
                            <td>Le {{ $moment(item.created_at).format('DD/MM/YYYY à HH:mm') }}</td>
                            <td>
                                <v-btn variant="flat" color="primary-dark" size="small" class="text-bold"
                                    @click="buy_dossard(item)">
                                    Acheter !
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-table>

            </div>

        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PublicService from "@/services/public.service";

export default {
    name: 'BourseDossardsList',
    data() {
        return {
            bourse_dossards_items: [],
        }
    },
    computed: {
        ...mapStores(useMainStore),
        is_mobile() {
            return this.$vuetify.display.smAndDown;
        },
    },
    methods: {

        get_icon(type) {
            switch (type) {
                case 'option':
                    return 'mdi-flash';
                case 'activite':
                    return 'mdi-nature-people';
                case 'article':
                    return 'mdi-shopping-outline';

                default:
                    return 'mdi-plus';
            }
        },
        parcours_name(item) {
            const course_name = item.course.nom;
            const vague_name = item.vague && item.vague != '' ? " (Vague " + item.vague + ")" : "";
            return course_name + vague_name;
        },
        buy_dossard(item) {

            // vider le booking
            this.mainStore.bookingSystem.booking.clearState();
            this.mainStore.bookingSystem.equipes.clearState();


            this.$router.push({ name: 'BuyDossardBourse', params: { id_dossard_bourse: item.id } });
        },
        async loadBourseDossardsItems() {
            const id_module = this.mainStore.module.id;
            let request = await PublicService.getBourseDossardsItems(id_module);
            if (request) {
                this.bourse_dossards_items = request;
            }
        }
    },
    async created() {
        await this.loadBourseDossardsItems();

    }
}
</script>

<style lang="scss" scoped></style>